import React, { useContext, useState, useEffect } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material'
import { AuthContext } from '../../context/AuthContext'
import FixTaskModal from '../commonUnit/FixTaskModal'
import { getAvailableCRNs } from '../../service/sessionService'

const AddSessionDialog = ({ open, setOpen, handleAddSession }) => {
  const { currentUser } = useContext(AuthContext)
  const [generateDescription, setGenerateDescription] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  // Note: change crn to an array for multiple selections
  const [newSession, setNewSession] = useState({
    subject: '',
    crn: [],
    task: '',
    type: '',
  })

  // Get available CRNs
  const [availableCRNs, setAvailableCRNs] = useState([])

  useEffect(() => {
    const fetchCRNs = async () => {
      const crns = await getAvailableCRNs()
      setAvailableCRNs(crns)
    }
    fetchCRNs()
  }, [])

  useEffect(() => {
    if (!isModalOpen && generateDescription !== '') {
      setNewSession({ ...newSession, task: generateDescription })
    }
  }, [generateDescription, isModalOpen])

  const handleChange = (e) => {
    const { name, value } = e.target
    // For the CRN field, value is already an array when multiple is true
    setNewSession({ ...newSession, [name]: value })
  }

  const handleAISuggestion = () => {
    setGenerateDescription(newSession.task)
    setIsModalOpen(true)
  }

  const handleCloseDialog = () => {
    setOpen(false)
    setNewSession({
      subject: '',
      crn: [],
      task: '',
      type: '',
    })
  }

  // Iterate over each selected CRN to create separate sessions
  const handleSubmit = () => {
    newSession.crn.forEach((selectedCrn) => {
      const sessionData = { ...newSession, crn: selectedCrn }
      handleAddSession(sessionData)
    })
    handleCloseDialog()
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Add New Session</DialogTitle>
      <DialogContent style={{ minHeight: '300px' }}>
        <FormControl fullWidth variant="outlined" className="form-control">
          <InputLabel id="crn-label">CRN</InputLabel>
          <Select
            labelId="crn-label"
            name="crn"
            multiple
            value={newSession.crn}
            onChange={handleChange}
            label="CRN">
            {availableCRNs.map((crn) => (
              <MenuItem key={crn} value={crn}>
                {crn}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          autoFocus
          margin="dense"
          name="subject"
          label="Subject"
          type="text"
          fullWidth
          value={newSession.subject}
          onChange={handleChange}
        />
        <FormControl fullWidth variant="outlined" className="form-control">
          <InputLabel id="type-label">Type</InputLabel>
          <Select
            className="type-select"
            labelId="type-label"
            value={newSession.type}
            onChange={handleChange}
            name="type"
            label="Type">
            <MenuItem value={'Auto Grouping'}>Auto Grouping</MenuItem>
            <MenuItem value={'Audio'}>Audio</MenuItem>
            <MenuItem value={'Helper/Helpee'}>Helper/Helpee</MenuItem>
            <MenuItem value={'Blockly'}>Blockly</MenuItem>
            <MenuItem value={'Blockly Shared'}>Blockly Shared</MenuItem>
            <MenuItem value={'Vizmental'}>Vizmental</MenuItem>
            <MenuItem value={'SQL Schema'}>SQL Schema</MenuItem>
            <MenuItem value={'SQL Select'}>SQL Select</MenuItem>
            <MenuItem value={'Java Functions'}>Java Functions</MenuItem>
            <MenuItem value={'Java Classes'}>Java Classes</MenuItem>
            <MenuItem value={'CPP'}>CPP</MenuItem>
          </Select>
        </FormControl>
        <TextField
          margin="dense"
          name="task"
          label="Task"
          type="text"
          fullWidth
          multiline
          rows={6}
          value={newSession.task}
          onChange={handleChange}
          placeholder=""
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAISuggestion} color="primary">
          AI Assistant
        </Button>
        <Button onClick={handleCloseDialog} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          Add
        </Button>
      </DialogActions>
      {isModalOpen && (
        <FixTaskModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          taskContent={generateDescription}
          setTaskContent={setGenerateDescription}
        />
      )}
    </Dialog>
  )
}

export default AddSessionDialog
